import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Row } from "reactstrap";
import { DateRangePicker } from "rsuite";
import SweetAlert from "sweetalert2";
import Breadcrumbs from "../../../layout/breadcrumb";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import PreLoader from "../../../share-components/ui/preLoader";
import withReducer from "../../../store/withReducer";
import partnerPromotionReducer from "../store";
import {
  deletePartnerPromotion,
  getPartnerPromotionList,
  getPartnerPromotionSettings,
  selectPartnerPromotionsDiscounts,
  setPartnerPromotionSettings,
  exportDifferenceDiscountReport,
} from "../store/partnerPromotionSlice";

const { afterToday } = DateRangePicker;

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const styles = {
  minHeight: "50px !important",
  border: "none !important",
  display: "block",
  paddingLeft: 0,
  fontSize: 12,
};

function PartnersPromotions() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tableLoading, isSetTableLoading] = useState(false);
  const [isDownloadReport, isSetDownloadReport] = useState(false);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([null, null]);
  const [creationDateRange, setCreationDateRange] = useState([sevenDays, TodayDate]);
  const [timer, setTimer] = useState(null);
  const [page, setPage] = useState(1);
  const [orderCheckBoxData, setOrderCheckBoxData] = useState({ idArray: [] });
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.settings);
  const partnerPromotionsData = useSelector(selectPartnerPromotionsDiscounts);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [partner, setPartner] = useState(null);
  const [agreedBy, setAgreedBy] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  const [name, setName] = useState("");
  const [includeSalesItems, setIncludeSalesItem] = useState(null);

  const [promotionStartDate, promotionEndDate] = dateRange;
  const [createStartDate, createEndDate] = creationDateRange;

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [
    dispatch,
    promotionStartDate,
    promotionEndDate,
    createStartDate,
    createEndDate,
    currentPage,
    pageSize,
    partner,
    name,
    includeSalesItems,
    agreedBy,
    createdBy,
  ]);

  const getData = () => {
    isSetTableLoading(true);
    const data = {
      page: currentPage,
      pageSize: pageSize,
      start_date: promotionStartDate ? moment(promotionStartDate).format("YYYY-MM-DD") : null,
      end_date: promotionEndDate ? moment(promotionEndDate).format("YYYY-MM-DD") : null,
      created_start_date: moment(createStartDate).format("YYYY-MM-DD"),
      created_end_date: moment(createEndDate).format("YYYY-MM-DD"),
      name,
      is_include_sales_iterm: includeSalesItems,
      partner,
      agreed_by: agreedBy,
      created_by: createdBy,
    };
    dispatch(getPartnerPromotionList(data)).then((res) => {
      if (!res.error) {
        setLoading(false);
      }
      isSetTableLoading(false);
    });
  };

  const dataMenu = [
    {
      type: 0,
      text: "Partners Promotions",
    },
  ];

  const IncludeSalesItemsOptions = [
    { value: "0", label: "No" },
    { value: "1", label: "Yes" },
  ];

  const filteredPartnersOptions = allSettings?.partners
    .filter((type) => type.name.toLowerCase())
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const agreedByPartnersOptions = allSettings?.users
    .filter((user) => user.name?.toLowerCase() && (user.role?.id === 1 || user.role?.id === 2))
    .map((type) => ({
      value: type.id,
      label: type.name,
    }));

  const pageChange = (e) => {
    setCurrentPage(e);
  };

  const onPageSizeChange = (e) => {
    setPageSize(e);
  };

  const onAdd = () => {
    history.push(`/product/partners-promotions/create`);
  };

  const onEdit = (row) => {
    history.push(`/product/partners-promotions/${row.id}/edit`);
  };

  const onView = (row) => {
    history.push(`/product/partners-promotions/${row.id}/view`);
  };

  const onDelete = (row) => {
    SweetAlert.fire({
      title: "Are you sure want to delete this partner promotion?",
      // text: "Once confirmed, the return request will be sent to the system",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "No, cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(deletePartnerPromotion(row.id)).then((res) => {
          setLoading(false);
        });
      }
    });
  };

  const eventExportDifferenceDiscountReport = () => {
    if (isDownloadReport) {
      return;
    }
    isSetDownloadReport(true);
    const data = {
      start_date: promotionStartDate ? moment(promotionStartDate).format("YYYY-MM-DD") : null,
      end_date: promotionEndDate ? moment(promotionEndDate).format("YYYY-MM-DD") : null,
      created_start_date: moment(createStartDate).format("YYYY-MM-DD"),
      created_end_date: moment(createEndDate).format("YYYY-MM-DD"),
      name,
      is_include_sales_iterm: includeSalesItems,
      partner,
      agreed_by: agreedBy,
      created_by: createdBy,
    };
    dispatch(exportDifferenceDiscountReport(data)).then((res) => {
      const link = document.createElement("a");
      link.href = res.payload;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      link.remove();
      isSetDownloadReport(false);
    });
  };


  return (
    <Fragment>
      {loading ? (
        <>
          <PreLoader></PreLoader>
        </>
      ) : (
        <>
          <Breadcrumbs title="Partners Promotions" data={dataMenu} />
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid">
              <Card>
                <Col sm="12">
                  <Row>
                    <Col sm="3">
                      <div className="p-3 custom-daterange">
                        <p className="mb-0">Promotions Date</p>
                        <DateRangePicker
                          size="lg"
                          style={styles}
                          appearance="subtle"
                          placeholder="Select Promotion Date Range"
                          className="form-control hide-border-control"
                          character=" - "
                          format="dd/MM/yyyy"
                          defaultValue={
                            promotionStartDate && promotionEndDate ? [new Date(promotionStartDate), new Date(promotionEndDate)] : undefined
                          }
                          onChange={(date) => {
                            if (date) {
                              setDateRange(date);
                            } else {
                              setDateRange([null, null]);
                            }
                          }}
                          cleanable={true}
                        />
                      </div>
                    </Col>
                    <Col sm="3">
                      <div className="p-3">
                        <p className="mb-0">Created Date</p>
                        <DatePicker
                          paddingLeft={2}
                          dateRange={creationDateRange}
                          dateRangeChange={(date) => {
                            setCreationDateRange(date);
                          }}
                          defaultValue={[TodayDate, sevenDays]}
                        />
                      </div>
                    </Col>

                    <Col sm="">
                      <div className="float-sm-right" style={{ marginBottom: "1.5rem", marginTop: "1.5rem" }}>
                        <Link className="btn btn-link text-primary" to={`${process.env.PUBLIC_URL}/product/partners-promotions/difference-discount`}>List Difference Discount</Link>
                        <button type="button" onClick={onAdd} className="btn btn-sm btn-dark ml-2">
                          <i className="fa fa-plus mr-1"></i> Add New Promotion
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Card>
              <Row>
                <Col md="">
                  <Select
                    placeholder={<div>Filter By Partner</div>}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={filteredPartnersOptions}
                    onChange={(e) => {
                      setPartner(e ? e.value : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </Col>
                <Col md="">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                  >
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        style={{ paddingTop: 24, paddingBottom: 24 }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        placeholder="Promotion Name"
                      />
                    </FormGroup>
                  </Form>
                </Col>
                <Col md="">
                  <Select
                    placeholder={<div>Agreed By</div>}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={agreedByPartnersOptions}
                    onChange={(e) => {
                      setAgreedBy(e ? e.value : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </Col>
                <Col md="">
                  <Select
                    placeholder={<div>Created By</div>}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={agreedByPartnersOptions}
                    onChange={(e) => {
                      setCreatedBy(e ? e.value : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </Col>
                <Col md="">
                  <Select
                    placeholder={<div>Include Sales Items</div>}
                    className="select2-filter"
                    isClearable
                    cacheOptions
                    styles={customStyles}
                    options={IncludeSalesItemsOptions}
                    onChange={(e) => {
                      setIncludeSalesItem(e ? e.value : null);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                </Col>
              </Row>
              {tableLoading ? (
                <div style={{ marginTop: "2rem" }}>
                  <PreLoader withoutText />
                </div>
              ) : (
                <Row>
                  <Col className="mt-3" sm="12">
                    <Card>
                      <CardBody>
                        <div className="table-responsive product-table">
                          <CommonDataTable
                            headerColumns={[
                              {
                                name: "Partner's Name",
                                selector: (row) => row.partner,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Start Date",
                                selector: (row) => row.start_date,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "End Date",
                                selector: (row) => row.end_date,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Promotion Name",
                                sortable: true,
                                center: false,
                                selector: (row) => row.name,
                              },
                              {
                                name: "Agreed By",
                                selector: (row) => row.agreed_by,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Created By",
                                selector: (row) => row.created_by,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Created At",
                                selector: (row) => row.created_at,
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Including Sales Items",
                                selector: (row) => row.is_include_sales_iterm, //this comes as 0 or 1. 0 mean No 1 mean Yes
                                sortable: true,
                                center: false,
                              },
                              {
                                name: "Action",
                                selector: (row) => row.id,
                                cell: (row) => {
                                  const startDate = new Date(row.start_date);
                                  const currentDate = new Date();

                                  const isValidDate = startDate > currentDate;

                                  return (
                                    <div>
                                      <a onClick={() => onEdit(row)} className={`btn btn-primary btn-sm px-2 py-1`}>
                                        <i className="fa fa-pencil" />
                                      </a>

                                      <a onClick={() => onView(row)} className={`btn btn-info btn-sm px-2 py-1 ml-2`}>
                                        <i className="fa fa-eye" />
                                      </a>

                                      {isValidDate && (
                                        <a onClick={() => onDelete(row)} className={`btn btn-danger btn-sm px-2 py-1 ml-2`}>
                                          <i className="fa fa-trash" />
                                        </a>
                                      )}
                                    </div>
                                  );
                                },
                                sortable: false,
                                center: true,
                              },
                            ]}
                            gridData={partnerPromotionsData}
                            paginationServer
                            noAction
                            paginationTotalRows={partnerPromotionState.tableRow}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            onChangeRowsPerPage={onPageSizeChange}
                            onChangePage={pageChange}
                          />
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </div>
          </Container>
        </>
      )}
    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PartnersPromotions);
